import { useEffect, useState } from "react";
import JobService from "../Service.js/jobService";
import { UserOutlined } from "@ant-design/icons";
import { Avatar } from "antd";
import appliedIcon from "../Assets/Icons/appliedicon.svg";
import { Timeline } from "antd";

import { isEmpty } from "lodash";
import Empty from "../Components/CommonCommponents/Empty";
import { useParams } from "react-router-dom";

const EmployeeProfile = () => {
  const { jobId } = useParams();
  const [candidateDetails, setCandidateDetails] = useState();
  const [jobDetails, setJobDetails] = useState();

  const getDetails = async () => {
    await JobService.getReferredCandidates(jobId)
      .then((response) => {
        setCandidateDetails(response.data.data);
      })
      .catch((err) => {});
  };
  console.log("candidateDetails", candidateDetails?.results[0]);
  const candidateData = candidateDetails?.results[0];

  useEffect(() => {
    getDetails();
  }, []);
  useEffect(() => {
    if (isEmpty(candidateDetails)) return;
    else {
      handleClick(candidateData?.candidate, candidateData?.job);
    }
  }, [candidateDetails]);

  const handleClick = async (candiadteId, jobId) => {
    await JobService.getReferredJobDetails(candiadteId, jobId)
      .then((response) => {
        setJobDetails(response.data.data);
      })
      .catch((err) => {});
  };
  return (
    <div className="pageContent w-full scrollbar-hide ">
      <div className="">
        <div className="mt-12 chart_div">
          <div className="lg:w-3/4 lg:flex lg:flex-row flex-col w-full ">
            <div className="lg:w-5/6 1xl:w-5/6 xs-xl:w-5/6 2xl:w-4/6 md:flex md:flex-row flex-col w-full sm:px-6 xs:px-6 md:px-6 lg:pl-0">
              <div className="w-full h-full ">
                <div className="rounded-xl border border-gray-300 pt-6 bg-[#FFF]">
                  <div
                    className="rounded-xl"
                    style={{ backgroundColor: "#FFF" }}
                  >
                    <div className="flex flex-row flex-wrap justify-between pt-6">
                      {candidateDetails?.results?.map((item, index) => {
                        const fullName = `${item?.first_name} ${item?.last_name}`;
                        return (
                          <div
                            className="w-full flex flex-wrap active:bg-[#F4F8FA] pl-6 cursor-pointer "
                            onClick={() =>
                              handleClick(item.candidate, item.job)
                            }
                          >
                            {/* <div className="bg-[#E7E7E7] h-[1px] w-full mt-4 mb-4"></div> */}
                            <div className="bg-[#E7E7E7] h-[1px] w-full"></div>
                            <div className="mt-6">
                              {Boolean(item.profile_picture_absolute_url) ? (
                                <img
                                  alt="profile-img"
                                  className="h-auto w-12 "
                                  src={item.profile_picture_absolute_url}
                                />
                              ) : (
                                <Avatar size={55} icon={<UserOutlined />} />
                              )}
                            </div>
                            <div className="pl-6 pt-1">
                              <p className="text-base font-semibold pt-2 ">
                                {fullName}
                              </p>
                              <div className="lg:flex flex-wrap lg:flex-row flex-col">
                                <p className="text-sm text-[#494949] font-normal pt-2">
                                  {item.email}
                                </p>

                                <span className="mx-2 mt-2 divider hidden lg:visible">
                                  |
                                </span>

                                <p className="text-sm text-[#494949] font-normal pt-2">
                                  {item.mobile_number}
                                </p>
                              </div>
                              <div className="rounded-full border border-gray-300 bg-white mt-2 mb-6 ">
                                <div className="flex p-1">
                                  <img className="pl-2" src={appliedIcon} />
                                  <p className="text-sm text-[#494949] font-normal px-2">
                                    {item.created_date}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="lg:w-5/6 xl:w-5/6 2xl:w-5/6 md:px-8 lg:pl-4 sm:px-4 xs:px-6 w-full sm:mt-4 md:mt-4 xs:mt-4 lg:mt-0 mb-8 ">
              <div className="w-full h-full">
                <div className="rounded-xl border border-gray-300 p-3 md:ml-0 bg-[#FFF]">
                  <div className="p-6">
                    {!isEmpty(jobDetails?.status) && (
                      <div>
                        <p className="text-xl font-semibold">
                          {jobDetails?.job_title}
                        </p>
                        <p className="text-base text-[#494949] font-normal pt-2">
                          {jobDetails?.description}
                        </p>
                        <div className="bg-[#E7E7E7] h-[1px] w-full mt-6 mb-4"></div>
                      </div>
                    )}
                    <div className="pt-4 pb-10">
                      <div className="">
                        {!isEmpty(jobDetails?.status) ? (
                          <div>
                            <p className="text-2xl font-semibold">
                              {jobDetails.status ? "job Status" : ""}
                            </p>
                            <div className="mt-8">
                              <Timeline>
                                {jobDetails?.status.map((item, index) => (
                                  <Timeline.Item
                                    key={index}
                                    dot={
                                      <img
                                        src={appliedIcon}
                                        alt=""
                                        style={{
                                          width: "24px",
                                          height: "24px",
                                        }}
                                      />
                                    }
                                  >
                                    <div className="px-4">
                                      <p className="text-base font-semibold text-black">
                                        {item?.key}
                                      </p>
                                      <p className="font-medium text-base">
                                        {item?.value}
                                      </p>
                                    </div>
                                  </Timeline.Item>
                                ))}
                              </Timeline>
                            </div>
                          </div>
                        ) : (
                          <div className="flex items-center justify-center">
                            <Empty description={<>{<p> No Activites</p>}</>} />
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default EmployeeProfile;
